import { useSettingsForm } from "@/hooks/useSettingsForm";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { ResourceManager } from "@/components/admin/ResourceManager";

export const AdminLocationPartners = () => {
  const { form, update, save, saving } = useSettingsForm();

  return (
    <div className="space-y-12">
      <div>
        <h1 className="font-display text-3xl text-ink tracking-tight mb-1">Lokasi Produksi</h1>
        <p className="text-stone2 text-sm mb-6">
          Titik lokasi yang tampil pada bagian "Lokasi Produksi" di halaman utama.
        </p>

        <div className="rounded-2xl bg-white border border-border/60 p-6 space-y-5 max-w-2xl">
          <div>
            <Label className="mb-2 block">Nama Lokasi</Label>
            <Input value={form.production_name} onChange={(e) => update("production_name", e.target.value)} />
          </div>
          <div>
            <Label className="mb-2 block">Alamat Lengkap</Label>
            <Input value={form.production_address} onChange={(e) => update("production_address", e.target.value)} />
          </div>
          <div>
            <Label className="mb-2 block">Tautan Google Maps</Label>
            <Input value={form.production_maps_url} onChange={(e) => update("production_maps_url", e.target.value)} />
          </div>
          <Button
            onClick={save}
            disabled={saving}
            data-testid="location-save-btn"
            className="rounded-full bg-honey hover:bg-honey-dark text-cream font-semibold"
          >
            {saving ? "Menyimpan..." : "Simpan"}
          </Button>
        </div>
      </div>

      <ResourceManager
        title="Titik Mitra"
        description="Kota mitra yang tampil pada peta 'Jaringan Mitra'. Koordinat x/y dalam persen (0-100 untuk x, 0-40 untuk y), lihat posisi pulau di peta situs."
        queryKey="partners"
        endpoint="/partners"
        columns={[
          { key: "city", label: "Kota" },
          { key: "x", label: "X (%)" },
          { key: "y", label: "Y (%)" },
        ]}
        fields={[
          { name: "city", label: "Nama Kota", type: "text" },
          { name: "x", label: "Posisi X (0-100)", type: "number", step: "0.5" },
          { name: "y", label: "Posisi Y (0-40)", type: "number", step: "0.5" },
          { name: "position", label: "Urutan", type: "number" },
        ]}
      />
    </div>
  );
};
